import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect,useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import mepcoLogo from '../../../images/mepcoLogo.png';
import pitcLogo from '../../../images/pitcLogo.png';
import usLogo from '../../../images/usLogo.png';
import './otpverification.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { Link } from 'react-router-dom';
import { cfpBaseUrl } from '../../../network/urls';
import eOpsLogo from '../../../images/eops.png'

const OTPverification = () => {

  let navigate = useNavigate();

  const { state } = useLocation();

  const { otpval, USERNAME } = state;

  const [Username, setUsername] = React.useState();
  const [disabled, setDisabled] = useState(true);
  const [counter, setCounter] = useState(120); // 2 minutes = 120 seconds
  useEffect(() => {
    let timer;
    if (disabled && counter > 0) {
      timer = setInterval(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
    } else if (counter === 0) {
      setDisabled(false);
    }

    return () => clearInterval(timer); // cleanup
  }, [disabled, counter]);

  // Format time as MM:SS
  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };
  React.useEffect(() => {
    setUsername(USERNAME);
  }, [])

  const [otp, setotp] = React.useState("")

  const otphandle = (newvalue) => {
    setotp(newvalue);
  }

  const Otpsubmit = async () => {
    // setViewBackdrop(true);
    const formdata = new FormData();
    formdata.append("userId", Username);
    formdata.append("otp", otp);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };

    await fetch(cfpBaseUrl + "customerFaciliationPortal/forgotPasswordOTPVerification", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          navigate('/reset-password', { state: Username })
        }
        else {
          console.log("Invalid OTP")
        }
      })
      .catch((error) => console.error(error));
    // setViewBackdrop(false);

  }

  return (
    <>
      <Grid className='background'>
        <div className='otpform'>
          <img src={eOpsLogo} className='logo' alt="" />
          <Box className='form-fields'>
            <Box className='otpbox'>
              <MuiOtpInput length={6} name="otp" value={otp} onChange={otphandle} />
            </Box>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              className='button'
              disabled={otp.length < 6}
              onClick={Otpsubmit}
              sx={{
                mt: 3, mb: 2, fontSize: 'small', '&:hover': {
                  backgroundColor: 'black',
                  color: 'white',
                },
                height: 40,
                textTransform: 'capitalize'
              }}
            >
              Confirm
            </Button>
            < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
            <Grid className='powered-by'>
              <Box className='form-bottom-link'>
                {disabled ? (
                  <span style={{ color: 'gray' }}>
                    Resend OTP in {formatTime(counter)}
                  </span>
                ) : (
                  <Link to='/forgot-password'>
                    Resend OTP
                  </Link>
                )}
              </Box>
              <Grid className='logos'>
                <img className='usaid' src={usLogo} alt="" />
                <img className='pitc' src={pitcLogo} alt="" />
              </Grid>
            </Grid>
          </Box>
        </div>
      </Grid>
    </>
  );

}

export default OTPverification;